import { ImpulseElement, registerElement, target, targets } from '@ambiki/impulse';
import type AwcAutocompleteElement from '@ambiki/impulse-view-components/dist/elements/autocomplete';

@registerElement('payroll-settings')
export default class PayrollSettingsElement extends ImpulseElement {
  @target() semiMonthlySelect: AwcAutocompleteElement;
  @target() monthlySelect: AwcAutocompleteElement;
  @targets() panels: HTMLElement[];

  /**
   * This action is fired when the radio button changes.
   */
  showSettings(event: Event) {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement)) return;

    const { value } = radio;
    this.markAsRequired(value);
    const panel = this.panels.find((p) => p.getAttribute('data-value') === value);
    if (panel) {
      this.selectPanel(panel);
    }
  }

  private selectPanel(panel: HTMLElement) {
    for (const p of this.panels) {
      const selected = p === panel;
      p.hidden = !selected;
    }
  }

  private markAsRequired(frequency: string) {
    switch (frequency) {
      case 'semi_monthly':
        this.semiMonthlySelect.required = true;
        this.monthlySelect.required = false;
        break;
      case 'monthly':
        this.monthlySelect.required = true;
        this.semiMonthlySelect.required = false;
        break;
      default:
        this.semiMonthlySelect.required = false;
        this.monthlySelect.required = false;
    }
  }
}
